import React, { useState } from "react";
import { Pagination as AntPagination } from "antd";
import PropTypes from "prop-types";
import _get from "lodash/get";
import { useTranslation } from "react-i18next";
import _isEmpty from "lodash/isEmpty";
import _isNumber from "lodash/isNumber";
import { DEFAULT_SORTER } from "../../utils/constants";
import { getSorterFilter, getSorterObj, searchQueryGenerator } from "../../utils/utils";
import "./Pagination.scss";

const DEFAULT_PAGE_SIZE = 20;
const PAGE_SIZE_OPTIONS = ["10", "20", "50", "100"];

const Pagination = ({ pagination, getList }) => {
  const { t } = useTranslation();
  const pageSize = _get(pagination, "size", DEFAULT_PAGE_SIZE);
  // For api query
  const [sorterFilterPage, setSorterFilterPage] = useState(() => {
    let cPage = _get(pagination, "number");
    cPage = _isNumber(cPage) ? cPage + 1 : 1;
    return {
      currentPage: cPage,
      pageSize,
      sorter: DEFAULT_SORTER,
      filters: {},
    };
  });
  // For antd pagination
  const [_pagination, setPagination] = useState({
    current: sorterFilterPage.currentPage,
    showSizeChanger: true,
    size: "small",
    pageSize: sorterFilterPage.pageSize,
    showQuickJumper: true,
    ...pagination,
  });

  const handlePageChange = async (currentPage, selectedPageSize) => {
    let sorter;
    if (!_isEmpty(pagination.sort)) {
      sorter = getSorterObj(pagination.sort);
    } else {
      sorter = null;
    }
    const payload = {
      ...pagination,
      currentPage,
      pageSize: selectedPageSize,
      sorter,
      keyword: pagination.keyword,
      filterCriteria: pagination.filterCriteria,
    };

    setSorterFilterPage(getSorterFilter(sorter, payload));
    const query = searchQueryGenerator(payload);
    await getList(query);
    setPagination({ ..._pagination, ...payload });
  };

  const paginationProps = {
    current: _get(pagination, "page", 0) + 1,
    total: _get(pagination, "totalElements", 0),
    showTotal: (total, range) => `${range[0]}-${range[1]} ${t("Pagination.Of")} ${total} ${t("Pagination.Items")}`,
    showSizeChanger: _pagination.showSizeChanger,
    pageSize,
    pageSizeOptions: PAGE_SIZE_OPTIONS,
    showQuickJumper: _pagination.showQuickJumper,
    locale: {
      items_per_page: t("Pagination.ItemsPerPage"),
    },
    size: "small",
    onChange: handlePageChange,
  };

  return (
    <div className="custom-pagination">
      <AntPagination {...paginationProps} />
    </div>
  );
};

Pagination.propTypes = {
  pagination: PropTypes.shape({
    currentPage: PropTypes.number,
    totalElements: PropTypes.number,
    size: PropTypes.number,
  }),
  getList: PropTypes.func,
};

export default Pagination;
